import { GenericBackendResponse } from '../genericBackendResponse';
import { IndividualPensionPlan } from './interfaces/IndividualPensionPlan';

const getIndividualPensionPlan = async (
	token: string
): Promise<GenericBackendResponse<IndividualPensionPlan | null>> => {
	try {
		const response = await fetch(
			`${process.env.REACT_APP_BASE_API}/users/individual-pension-plan`,
			{
				method: 'GET',
				headers: {
					'Content-Type': 'application/json',
					Authorization: `Bearer ${token}`
				}
			}
		);

		const responseData = await response.json();

		return responseData;
	} catch (error) {
		console.error('Error fetching individual pension plan:', error);
		return {
			success: false,
			data: null,
			code: 500,
			responseAt: new Date().toISOString(),
			debugId: 'individual-pension-plan-fetch-error',
			message: 'Error al obtener el plan de pensiones individual'
		};
	}
};

export default getIndividualPensionPlan;
